/**
 * Unions API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Вариант ответа.
 */
export interface AnswerOptionView { 
    /**
     * Вариант ответа
     */
    textValue?: string;
    /**
     * 
     */
    sortOrder?: number;
    isAlternative?: boolean;
    /**
     * Идентификатор вопроса
     */
    questionId?: string;
    /**
     * Идентификатор варианта ответа
     */
    id?: string;
}

